module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0035.png.037fb395.jpg";